<template>
  <el-container>
    <el-header>
      <headers></headers>
    </el-header>
    <el-container>
      <menus></menus>
      <el-main>
        <el-breadcrumb separator=">" class="breadcrumb-inner">
          <el-breadcrumb-item v-for="item in $route.matched" :key="item.path">
            {{ item.name }}
          </el-breadcrumb-item>
        </el-breadcrumb>
        <div class="tip-img" v-if="$route.matched[0]['name']!='系统设置' && $route.matched[0]['name']!='基本信息' && $route.matched[0]['name']!='广告审核'">
          <i class="el-icon-question"></i>
          <img :src="'../../../static'+$route.matched[1]['path']+'.png'" alt="" style="padding-right: 10px;"/>
        </div>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
  import headers from './header';
  import menus from './menus';
  export default{
    components:{
      menus:menus,
      headers:headers
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layout.vue


// WEBPACK FOOTER //
// src/components/layout.vue